export const getInitialState = (): any => ({
  modelSettingsData: {},
  modelSettingsStatus: 0
});
